
export class ButtonsMenuModel {
  create?: boolean;
  update?: boolean;
  back?: boolean;
  enable?: boolean;
  delete?: boolean;
  propertyId?: string;
  propertyActive?: string;
  showButtons?: boolean;
  hashButtons?: HashButtons;
  resend?: boolean;

  constructor(options: ButtonsMenuModel = {}) {
    this.back = options.back || false;
    this.create = options.create || false;
    this.enable = options.enable || false;
    this.delete = options.delete || false;
    this.propertyId = options.propertyId || null;
    this.propertyActive = options.propertyActive || null;
    this.showButtons = options.showButtons || false;
    this.update = options.update || false;
    this.hashButtons = options.hashButtons || new HashButtons();
    this.resend = options.resend || false;
  }
}

export class HashButtons {

  add?: any;
  save?: any;
  edit?: any;
  cancel?: any;
  unlock?: any;
  lock?: any;
  delete?: any;
  resend?: any;

  /*
    add: '',
    save: '',
    edit: '',
    cancel: '',
    unlock: '',
    lock: '',
    delete: ''
  */
  constructor(options: HashButtons = {}) {
    this.add = options.add || '';
    this.save = options.save || '';
    this.edit = options.edit || '';
    this.cancel = options.cancel || '';
    this.unlock = options.unlock || '';
    this.lock = options.lock || '';
    this.delete = options.delete || '';
    this.resend = options.resend || '';
  }
}
